export const SE_HOUSEHOLD_INFO_NAV_TREE = {
  label: 'SeHouseholdInfo', secondaryItems: [
    {
      label: 'SeHouseholdInfo',
      key: 'se-household-info',
      attributes: { href: '/docs/se-household-info/overview' }
    },
    {
      label: 'Feature Guardian Invite Modal',
      key: 'feature-guardian-invite-modal',
      attributes: { href: '/docs/se-household-info/feature-guardian-invite-modal'}
    }
  ]
}
